<template>
  <v-dialog class="the-app-dialogs" v-model="addDialog" persistent max-width="700px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-dolly</v-icon>
              <span class="px-3">{{ $t('Add New Raw Material') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="headline no-select pb-1">
              <v-layout justify-end />
            </v-flex>

            <v-layout row wrap>
              <v-flex xs12 class="pb-2 px-2">
                <v-text-field
                  id="material-focus-me"
                  v-model="form.theProductName"
                  :label="`${$t('Raw Material Name')} *`"
                  name="product_name"
                  box
                  hide-details
                  background-color="white"
                  :error="errors.has('product_name')"
                  v-validate="'required'"
                />
              </v-flex>

              <v-flex xs6 class="pa-2">
                <v-text-field
                  v-model="form.productBarcode"
                  :label="$t('Barcode')"
                  name="product_barcode"
                  box
                  hide-details
                  background-color="white"
                  :error="errors.has('product_barcode')"
                />
              </v-flex>

              <v-flex xs6 class="pt-2 px-2">
                <v-text-field
                  v-model="form.salePrice"
                  :label="`${$t('Sale Price')} (${systemCurrency}) *`"
                  name="product_sale"
                  box
                  hide-details
                  background-color="white"
                  :error="errors.has('product_sale')"
                  v-validate="'required|decimal:3|min_value:0'"
                />
              </v-flex>

              <v-flex xs11 :class="{ xs12: !hasPermissions(['product_types_store']) }" pa-2>
                <v-autocomplete
                  v-model="form.productTypeIdFk"
                  :items="fullProductTypesList"
                  :label="`${$t('Raw Material Type')}`"
                  box
                  hide-details
                  background-color="white"
                  :error="errors.has('product_type')"
                  data-vv-name="product_type"
                  :menu-props="{ transition: 'slide-y-transition' }"
                />
              </v-flex>

              <v-flex xs1 class="pt-2" v-if="hasPermissions(['product_types_store'])">
                <v-tooltip top>
                  <v-btn label @click="$emit('add-product-type')" slot="activator" icon fab small color="green">
                    <v-icon color="white" size="25">add</v-icon>
                  </v-btn>
                  <span>{{ $t('Add new raw material type') }}</span>
                </v-tooltip>
              </v-flex>

              <v-flex xs6 class="pa-2">
                <v-text-field
                  v-model="form.quantityAlarm"
                  :label="$t('Quantity Alarm')"
                  name="quantity_alarm"
                  box
                  hide-details
                  background-color="white"
                  :error="errors.has('quantity_alarm')"
                  v-validate="'integer'"
                />
              </v-flex>

              <v-flex xs6 class="pt-2 px-2">
                <v-text-field
                  v-model="form.quantityAlarmTotal"
                  :label="$t('Total Quantity Alarm')"
                  name="quantity_alarm_total"
                  box
                  hide-details
                  background-color="white"
                  :error="errors.has('quantity_alarm_total')"
                  v-validate="'integer'"
                />
              </v-flex>

              <!-- <v-flex xs12 class="pa-2">
                <v-text-field
                  v-model="form.expiryAlarm"
                  :label="$t('Expiration Alarm (No. of days before expiration date)')"
                  name="expire_alarm"
                  box
                  hide-details
                  background-color="white"
                  :error="errors.has('expire_alarm')"
                  v-validate="'integer'"
                />
              </v-flex>-->

              <v-flex xs6 class="px-2" style="margin-bottom:-20px">
                <v-checkbox
                  v-model="form.canBeSold"
                  :label="$t('Raw Material Can Be Sold')"
                  name="can_be_sold"
                  true-value="1"
                  false-value="0"
                  color="primary"
                  box
                  :error="errors.has('can_be_sold')"
                />
              </v-flex>

              <v-flex xs6 class="px-2" style="margin-bottom:-20px">
                <v-checkbox
                  v-model="form.canBePurchase"
                  :label="$t('Raw Material Can Be Purchase')"
                  name="can_be_purchase"
                  true-value="1"
                  false-value="0"
                  color="primary"
                  box
                  :error="errors.has('can_be_purchase')"
                />
              </v-flex>

              <v-flex xs12 class="pa-2">
                <v-textarea
                  v-model="form.productDescription"
                  :label="$t('Description')"
                  name="product_description"
                  box
                  hide-details
                  height="80"
                  background-color="white"
                  :error="errors.has('product_description')"
                />
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end align-center pr-2 pl-2>
              <v-checkbox color="primary" v-model="keepForm" :label="$t('Keep this form to add another one.')" />

              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnAddLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Add') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'add-component',

  props: {
    addDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      btnAddLoading: false,
      form: {
        canBeSold: '1',
        canBePurchase: '1'
      },
      keepForm: false
    }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      fullProductTypesList: 'productTypes/getFullProductTypesList'
    })
  },

  watch: {
    addDialog: {
      immediate: false,
      handler() {
        if (this.addDialog) {
          this.addEscKeyListener()
          this.resetForm()
          this.keepForm = false
        }
      }
    }
  },

  methods: {
    ...mapActions({
      addRawMaterial: 'rawMaterials/addRawMaterial'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.addDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    resetForm() {
      this.$validator.pause()
      for (let key in this.form) {
        this.form[`${key}`] = null
      }
      this.form.canBeSold = '1'
      this.form.canBePurchase = '1'
      this.$nextTick(() => {
        this.$validator.resume()
        // default veutify autofocus only one time works so we have to handled in this way.
        // document.getElementById('material-focus-me').focus()
      })
    },

    validateBeforeSubmit(event) {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnAddLoading = true

            // console.warn(this.form.tags)

            let formData = new FormData(event.target)
            formData.append('can_be_sold', this.form.canBeSold || '')
            formData.append('can_be_purchase', this.form.canBePurchase || '')
            formData.append('product_type_id_fk', this.form.productTypeIdFk || '')

            this.addRawMaterial(formData)
              .then(() => {
                this.btnAddLoading = false
                this.$emit('reset-datatable')
                if (this.keepForm) {
                  this.resetForm()
                } else {
                  this.$emit('hidemodal')
                }
              })
              .catch(() => {
                this.btnAddLoading = false
              })
          }
        })
        .catch(() => {
          this.btnAddLoading = false
        })
    }
  }
}
</script>

<style scoped />
